export const actionTypes = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  AUTHORIZING: 'AUTHORIZING',
  SET_IS_MOBILE_SSR: 'SET_IS_MOBILE_SSR',
  ADD_BOOKMARKS: 'ADD_BOOKMARKS',
  REMOVE_BOOKMARKS: 'REMOVE_BOOKMARKS',
  SET_OPEN_LOGOUT_POPUP: 'SET_OPEN_LOGOUT_POPUP',
  SET_COMMENT_FOCUS: 'SET_COMMENT_FOCUS',
  SET_OPEN_DUE_DATE_POPUP: 'SET_OPEN_DUE_DATE_POPUP',
  INIT_USER: 'INIT_USER',
  PLAY_ARTICLE: 'PLAY_ARTICLE',
  SET_OPEN_CONFIRM_LEAVE_PAGE_POPUP: 'SET_OPEN_CONFIRM_LEAVE_PAGE_POPUP',
  SET_CHATWOOT_WEBSITE_TOKEN: 'SET_CHATWOOT_WEBSITE_TOKEN',
  SET_ZALO_CONFIG: 'SET_ZALO_CONFIG',
  SET_COLLECTING_ACTION: 'SET_COLLECTING_ACTION',
  SET_HEALTH_INFO: 'SET_HEALTH_INFO',
  UPDATE_CART: 'UPDATE_CART',
  ADD_COMMUNITY_JOINED: 'ADD_COMMUNITY_JOINED',
  REMOVE_COMMUNITY_JOINED: 'REMOVE_COMMUNITY_JOINED',
  UPDATE_USER_INFO: 'UPDATE_USER_INFO',
}
